/* eslint-disable react-hooks/exhaustive-deps */
import { Col, Row, Spin, Typography } from 'antd';
import Layout from 'components/layout/Layout';
import { formatPrice } from 'helpers/formatPrice';

import Comingsoon from 'resources/img/upcoming_feature.png';
import { getProductSubCatProduct } from 'helpers/GetInitSubProduct';

import React, { useCallback, useEffect, useState } from 'react';
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom';

const { Title, Text } = Typography;
const PaketData = () => {
   const [loading, setLoading] = useState(false);
   const [products, setProducts] = useState([]);
   const [commingSoon, setCommingSoon] = useState(false);
   const [page, setPage] = useState(0);
   const [poinBOS, setPoinBOS] = useState(0);

   const { slug } = useParams();
   const initproduct = 'data-plan';
   const location = useLocation();
   const id = location.state?.id;
   const idPulsa = location.state?.idPulsa;
   const idPaket = location.state?.idPaket;
   const idBrandPulsa = location.state?.idBrandPulsa;
   const idBrandPaket = location.state?.idBrandPaket;
   const noTelepon = location.state?.noTelepon;
   const navigate = useNavigate();

   const getInitData = useCallback(
      async (loadMore = false) => {
         setLoading(true);
         !loadMore ? setPage(1) : setPage(page + 1);

         let params = [];
         params.push(`_limit=10`);
         params.push(`is_digipos=false`);
         params.push(`page=${loadMore ? page + 1 : page || 1}`);

         let product = await getProductSubCatProduct(
            id,
            `&${params.join('&')}`,
         );

         setProducts(product);
         setLoading(false);
         if (product.length === 0) {
            setCommingSoon(true);
         } else {
            setCommingSoon(false);
         }
      },
      [page, products, id],
   );
   useEffect(() => {
      setPoinBOS(localStorage.getItem('poinBOS') || 0);
      getInitData();
   }, []);
   const cekTagihan = (data) => {
      navigate('/Pulsa-konfirmasi-pembayaran', {
         state: {
            data: data,
            phone: noTelepon,
            initproduct: 'pulsa-national',
         },
      });
   };

   return (
      <>
         {loading && (
            <div>
               <Spin size="large" className="spin-area"></Spin>
               <div className="loading-spin"></div>
            </div>
         )}
         <Layout header="none" headerTitle={slug}>
            <header
               className="ant-layout-header"
               style={{ display: 'flex', left: 0 }}
            >
               <Row
                  className="ant-row-center ant-row-middle"
                  style={{ maxWidth: '500px', width: '100%' }}
               >
                  <Col span={24}>
                     <Row className="ant-row-center ant-row-middle">
                        <Col span={4} className="col-left">
                           <Link
                              to="/pulsa-paket-data?isBack=true"
                              state={{
                                 noTelepon: noTelepon,
                                 id: idPulsa,
                                 IdPaketData: idPaket,
                                 idBrandPulsa: idBrandPulsa,
                                 idBrandPaket: idBrandPaket,
                              }}
                           >
                              <svg
                                 width="18"
                                 height="17"
                                 viewBox="0 0 18 17"
                                 fill="none"
                                 xmlns="http://www.w3.org/2000/svg"
                              >
                                 <path
                                    d="M8.36108 1.38885L1 8.5M1 8.5L8.36108 15.6111M1 8.5H17"
                                    stroke="#EA217A"
                                    strokeWidth="2"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                 />
                              </svg>
                           </Link>
                        </Col>
                        <Col span={16} className=" header-title col-center">
                           <h4
                              className="ant-typography"
                              style={{ margin: '0px' }}
                           >
                              {slug}
                           </h4>
                        </Col>{' '}
                        <Col span={4} className="col-left"></Col>
                     </Row>
                  </Col>
               </Row>
            </header>
            <Row className="container-index Top-UP">
               {products?.map((item, index) => (
                  <Row
                     key={index}
                     style={{ marginBottom: '15px', cursor: 'pointer' }}
                     onClick={
                        item?.is_purchasable &&
                        item?.product_price?.total < poinBOS
                           ? () => cekTagihan(item)
                           : null
                     }
                     className={
                        item?.is_purchasable &&
                        item?.product_price?.total < poinBOS
                           ? 'detail-paket-data enable'
                           : 'detail-paket-data disable'
                     }
                  >
                     <Col span={24}>
                        <Text strong>{item?.name}</Text>
                        <br />
                        <Text>{item?.description} </Text>
                     </Col>
                     <Col
                        span={12}
                        className="price"
                        style={{
                           color: '#cc0a78',
                        }}
                     >
                        {formatPrice(item?.product_price?.total)}
                     </Col>{' '}
                     <Col
                        span={12}
                        className="col-right"
                        style={{ color: 'red' }}
                     >
                        {!item?.is_purchasable ? (
                           <Text className="dalam-kendala">Dalam Kendala</Text>
                        ) : item?.product_price?.total > poinBOS ? (
                           <Text className="dalam-kendala">
                              Poin tidak cukup
                           </Text>
                        ) : null}
                     </Col>
                  </Row>
               ))}
               {commingSoon ? (
                  <Row>
                     <Col
                        span={24}
                        className="cooming-soon"
                        style={{ marginBottom: 30 }}
                     >
                        <img
                           src={Comingsoon}
                           alt="indosat"
                           className="comingsoon-img"
                        />
                     </Col>
                     <Col
                        span={24}
                        style={{ textAlign: 'center', padding: '0 40px' }}
                     >
                        <Title level={5}>Layanan ini akan segera hadir</Title>
                        <Text>
                           Mohon bersabar menunggu, Layanan ini akan segera
                           hadir di Wispay dalam waktu dekat.
                        </Text>
                     </Col>
                  </Row>
               ) : null}
            </Row>
         </Layout>
      </>
   );
};

export default PaketData;
